import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question:
      "How does outsourcing to a machine learning development company work?",
    answer: `<p>Our experts collaborate with you to define requirements, develop custom ML models, integrate them into your systems, and provide ongoing support for optimal performance.</p>`,
  },
  {
    question: "What kind of applications can you build using machine learning?",
    answer: `<p>We create predictive analytics, fraud detection, customer segmentation, recommendation systems, natural language processing, computer vision, and more, tailored to your business needs.</p>`,
  },
  {
    question: "How long does it take to develop a custom ML solution?",
    answer: `<p>Development timelines vary based on complexity and data availability, typically ranging from a few weeks for simple models to several months for complex systems.</p>`,
  },
  {
    question: "How do you ensure the security and privacy of our data?",
    answer: `<p>We use advanced encryption, access controls, and compliance with industry standards to ensure your data's security, privacy, and integrity throughout the ML development process.</p>`,
  },
  {
    question: "What is the difference between ML and AI?",
    answer: `<p>AI encompasses all technologies enabling machine intelligence. ML is a subset of AI focused on developing algorithms that learn from data and make predictions or decisions autonomously.</p>`,
  },
  {
    question: "What post-deployment support do you offer for ML solutions?",
    answer: `<p>We provide continuous monitoring, maintenance, and optimization to ensure ML models adapt to new data, maintain performance, and meet evolving business needs.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#F8F8FB" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>ML Development Services FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
